import script from "./CompletionMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompletionMenu.vue?vue&type=script&setup=true&lang=ts"

import "./CompletionMenu.vue?vue&type=style&index=0&id=08461938&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08461938"]])

export default __exports__